export default __webpack_public_path__ + "static/media/cash-outline.6000e6b8.svg";